import { Icon } from "@iconify/react";
import FrontText from "../FrontText";
import { useTranslation } from "react-i18next";
import { Link } from "@inertiajs/react";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";

const FrontStickySeeOnMap = ({text = '', link}) => {
    const { t, i18n } = useTranslation();

    if (!text) {
        text = t('warehouses.viewOnTheMap')
    }
    return (
        <div className="absolute top-0 right-0 h-full pointer-events-none md:block hidden">
            <div className="sticky top-52">
                <Link href={link} className="pointer-events-auto rounded-l-10 border-dark-blue-standard bg-light-blue 2xl:py-c22 py-4 2xl:px-5 px-4 flex flex-col items-center justify-center text-white hover:text-yellow hover:opacity-90 transition-all ease-in-out duration-300">
                    <Icon icon='tabler:world-code' width={40} height={40} className="text-yellow" />

                    <div className="flex items-center py-1.5 px-3 transition-all ease-in-out duration-300">
                        <FrontText textSize='14/17' className="font-medium">
                            <span>{text}</span>
                        </FrontText>

                        <Icon icon='mingcute:right-fill' width={20} height={20} />
                    </div>
                </Link>
            </div>
        </div>
    );
};

export default FrontStickySeeOnMap;
